// 用于设置表格的行样式
export const useRowStyle = (row, rowIndex, field, values) => {
    // 指定固定的某一列field满足values中的值时，设置背景色
    if (values.includes(row[field])) {
        if (row[field] === '合计') {
            return {
                background: '#F5F9FF',
                fontWeight: 'bold'
            };
        }
        return {
            background: '#F5F9FF'
        };
    }
    return {};
};
